import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  loading: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingSection: {
    height: 100,
  },
});
